"use client"

import React from "react"

export function SpeakerMeter({
  label,
  level,
}: {
  label: string
  level: number
}) {
  return (
    <div className="flex items-center gap-2">
      <span className="w-16 shrink-0 text-xs text-coval-text-muted">
        {label}
      </span>
      <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-surface-1">
        <div
          className="h-full rounded-full bg-coval-progress transition-[width] duration-75"
          style={{ width: `${Math.round(level * 100)}%` }}
        />
      </div>
    </div>
  )
}
